


































































































import VueBase from '@/VueBase'
import { Component } from 'vue-property-decorator'
import { StrategyListObj } from '@/views/setting/types'

@Component({ name: 'templateManage' })
export default class templateManage extends VueBase {
  private tableData: Array<StrategyListObj> = []
  private page = 1
  private page_size = 20
  private total = 0
  private name = ''
  private async stateChange(row: any) {
    this.loadingStart()
    const res = await this.services.setting.update_scan_strategy({
      ...row,
      ...{ status: row.status === 0 ? 1 : 0 },
    })
    this.loadingDone()
    if (res.status === 201) {
      this.$message.success(res.msg)
      this.getTableData()
    } else {
      this.$message.error(res.msg)
    }
  }

  private handleSizeChange(val: number) {
    this.page_size = val
    this.getTableData()
  }

  private handleCurrentChange(val: number) {
    this.page = val
    this.getTableData()
  }

  async created() {
    this.loadingStart()
    await this.getTableData()
    this.loadingDone()
  }
  get userInfo(): { username: string } {
    return this.$store.getters.userInfo
  }

  private async getTableData() {
    this.loadingStart()
    const { status, msg, data, page } =
      await this.services.setting.get_scan_strategy({
        page: this.page,
        page_size: this.page_size,
        name: this.name,
      })
    this.loadingDone()
    if (status !== 201) {
      this.$message({
        type: 'error',
        message: msg,
        showClose: true,
      })
      return
    }
    if (data.length === 0 && this.page > 1) {
      this.page--
      await this.getTableData()
      return
    }
    this.tableData = data
    this.total = page.alltotal
  }

  toPath(view: any, id: any) {
    this.$router.push({
      name: 'template',
      query: {
        view,
        id,
      },
    })
  }

  private templateDialogAdd() {
    this.$router.push({ name: 'template' })
  }
  private templateDialogEdit(row: any) {
    this.$router.push({
      name: 'template',
      query: {
        id: row.id,
      },
    })
  }
  private async templateDialogDelete(row: any) {
    this.$confirm(
      this.$t('views.templateManage.deleteWarning') as string,
      this.$t('views.templateManage.deletePop') as string,
      {
        confirmButtonText: this.$t('views.templateManage.enter') as string,
        cancelButtonText: this.$t('views.templateManage.clear') as string,
        type: 'warning',
      }
    ).then(async () => {
      const res = await this.services.setting.delete_scan_strategy_one({
        id: row.id,
      })
      if (res.status === 201) {
        this.$message({
          type: 'success',
          message: res.msg,
        })
        this.getTableData()
      } else {
        this.$message({
          type: 'error',
          message: res.msg,
        })
      }
    })
  }
}
